const baseUrl = 'https://hms-api-fpcmh0csfdb4f0f6.eastus2-01.azurewebsites.net/api/';
//const baseUrl = 'http://localhost:59231/api/';

const AppSettings = {
    apiRoutes: {
        login: baseUrl + 'identity/login',
        registerAdmin: baseUrl + 'identity/registeradmin',
        changePassword: baseUrl + 'identity/changepassword',
        validateToken: baseUrl+ 'identity/validatetoken',

        getDoctorProfile: baseUrl + 'doctor/getprofile/',
        GetAllDoctors: baseUrl + "doctor/getall",
        ToggleDoctor: baseUrl + 'doctor/toggle',
        UpdateFees: baseUrl + 'doctor/updatefees',
        
        GetAllPatients: baseUrl + 'patient/getall',

        GetAllAppoinments: baseUrl + 'appoinment/getall',
        ToggleAppoinment: baseUrl + 'appoinment/toggle',
        
        getInvoiceById: baseUrl + 'invoice/get/',
        GetAllInvoices: baseUrl + 'invoice/getall',
        DeleteInvoice: baseUrl + 'invoice/delete',
    
        GetAllReviews: baseUrl + 'review/getall',
        DeleteReview: baseUrl + 'review/delete',

        UpsertSetting: baseUrl + 'setting/upsert',
        LoadSetting: baseUrl + 'setting/load',

        UpsertSpeciality: baseUrl + 'speciality/upsert',
        GetAllSpeciality: baseUrl + 'speciality/getall',
        DeleteSpeciality: baseUrl + 'speciality/delete',

        GetAdminDashboardCount: baseUrl + 'admin/getcount',
        GetChartData: baseUrl + 'admin/getchartdata',

        UpsertInventory: baseUrl + 'inventory/upsert',
        GetAllInventory: baseUrl + 'inventory/getall',
        DeleteInventory: baseUrl + 'inventory/delete',

        UpsertService: baseUrl + 'service/upsert',
        GetAllService: baseUrl + 'service/getall',
        DeleteService: baseUrl + 'service/delete'
    }
}

module.exports = AppSettings;